import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist, createJSONStorage } from 'zustand/middleware'

export enum BottomTabsKey {
    TERMINAL = 'terminal',
    OUTPUT = 'output',
}

interface TabKeyState {
    bottomTabsActiveKey: BottomTabsKey
    outputTabsActiveKey?: string
    setBottomTabsActiveKey: (key: BottomTabsKey) => void
    setOutputTabsActiveKey: (key?: string) => void
}

export const useTabKeyStore = create<TabKeyState>()(
    persist(
        immer((set) => ({
            bottomTabsActiveKey: BottomTabsKey.TERMINAL, // Default value
            outputTabsActiveKey: undefined, // Default value
            
            setBottomTabsActiveKey: (key: BottomTabsKey) => 
                set((state) => {
                    state.bottomTabsActiveKey = key
                }),
                
            setOutputTabsActiveKey: (key?: string) => 
                set((state) => {
                    state.outputTabsActiveKey = key
                })
        })),
        {
            name: "tab-key-storage",
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ 
                bottomTabsActiveKey: state.bottomTabsActiveKey,
                outputTabsActiveKey: state.outputTabsActiveKey 
            })
        }
    )
)